import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeBuildPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Construction d'un runtime et son journal (porting README #42). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/builds/$buildId')({
  component: RuntimeBuildRoute,
});

function RuntimeBuildRoute() {
  const { tenant, runtimeId, buildId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: runtimeId, mono: true },
        { label: buildId, mono: true },
      ]}
    >
      <RuntimeBuildPage tenantId={tenant} runtimeId={runtimeId} buildId={buildId} />
    </ConsoleShell>
  );
}
